import * as React from 'react'
import { connect, Dispatch } from 'react-redux'
import { RouteConfigComponentProps } from 'react-router-config'

import { IRootState } from '../../common/reducers'

interface IOwnProps {
  location: any
}

interface IStateProps {
  currentSite: string
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { common: { currentSite } } = state

  return {
    currentSite
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<IRootState>,
  ownProps: IOwnProps
) => {
  return {}
}

export type Props = IOwnProps & IStateProps

const createNotFoundContainer = (component: React.ComponentType<Props>) => {
  return connect<IStateProps, {}, IOwnProps, IRootState>(
    mapStateToProps,
    mapDispatchToProps
  )(component)
}

export default createNotFoundContainer



// WEBPACK FOOTER //
// ./client/containers/notFoundContainer.ts